import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '@core/broadcaster/broadcaster.service';

@Injectable()
export class RefreshEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(data: string): void {
    this.broadcaster.broadcast(RefreshEvent, data);
  }

  on(): Observable<string> {
    return this.broadcaster.on<string>(RefreshEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/events/RefreshEvent.ts